var map = {
	"./hydrant.svg": 7935,
	"./manhole.svg": 1543,
	"./sewerline.svg": 8885,
	"./trafficSign.svg": 1957,
	"./valve.svg": 1655,
	"./waterline.svg": 1362,
	"./watermeter.svg": 6759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2331;